import _ from 'lodash';
import 'react-awesome-slider/dist/styles.css';
import 'react-awesome-slider/dist/custom-animations/fold-out-animation.css';

import React, { Fragment } from 'react';
import { inject } from 'mobx-react';
import { NavLink } from 'react-router-dom';
import artistStore from '../../../shared/stores/artist-store';
import albums from '../artist/albums';

const injectWithStores = inject('artistStore', 'userStore');

const getArtists = (store, subs) => {
	let artistList = [];
	subs.forEach((s) => {
		let artist = store.getArtistByID(s);
		artistList.push(artist);
	})

	if(artistList.some(a=>a === undefined)) {
		return [];
	}
	return artistList;
}
export default injectWithStores(
	({ artistStore, userStore}) => {
		artistStore.fetchIfEmpty();
		if (artistStore.isLoading) {

			return (<h1>Loading...</h1>);
		}
		
		const user = userStore.getLoggedInUser();

		const activeSubscriptions = user.subscribedTo.filter(s => s.active !== false);
		const artists = getArtists(artistStore, activeSubscriptions);
		const allAlbums = artists.map(a=>a.albums);
		if(_.isEmpty(activeSubscriptions) || _.isEmpty(artists)) {
			return (
				<div className="cell small-12 text-center" style={{marginTop:'20vh'}}>
					<div className="no-result-text dropfade-text">No albums available</div>
					<div className="no-result-text dropfade-subtext margin-top-1" style={{fontSize:'1.25em'}}>
						Albums created by the artists you are subscribed to will appear here.
					</div>
				</div>
			)
		}
		return (
			
			<div style={{marginTop: '7vh'}} className="grid-x grid-padding-x">
				{
					allAlbums.flat().map(({ artwork, name, id }) => (
						<div key={ id } className="cell shrink text-center">
							<NavLink
								to={ `/album/${id}` }
								className="image medium"
								style={
									{
										display: 'block',
										backgroundImage: `url("/assets/public/s3/img/${artwork}")`,
										width: '11.5rem',
										height: '11.5rem',
										boxShadow: 'rgba(0, 0, 0, 0.4) 0px 4px 20px'
									}
								}>
							</NavLink>
							<p className="primary-font margin-top-1" style={{fontSize: '1.4em'}}>{ name }</p>
						</div>
					))
				}
			</div>
		);
	}
);
